import { render, staticRenderFns } from "./relatedTask.vue?vue&type=template&id=617783c8&"
import script from "./relatedTask.vue?vue&type=script&lang=js&"
export * from "./relatedTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports